export default {
  GET_PATIENTS: "GET_PATIENTS",
};
